module.exports = __webpack_public_path__ + "media/images/icon-hidden-53de1b269dcfaa7e0706eca2546241ad.svg";